import { css, Interpolation, Theme } from '@emotion/react'
import { scaleBorderRadius } from 'theme/utils'

export const link: Interpolation<Theme> = (theme: Theme) => css`
  border: 1px solid ${theme.backgrounds.backgroundOne};
  border-radius: ${scaleBorderRadius(theme.shape.borderRadius, 2.5)};
`
